//**auto-generated don't edit this code**//
import {ContractHttpClient} from '@esgi/contracts';
import {Observable} from 'rxjs';
import {Response} from '../../../../../types/esgi.countries/endpoints/common/states/by-country-id/response';

export function statesByCountryId(httpClient: ContractHttpClient) {
	return (countryID: number): Observable<Response> => {
		return httpClient.request<Response>(
			'GET',
			'/v2/modules/user-account/states/by-country-id',
			countryID,
		).asObservable();
	};
}
